// extracted by mini-css-extract-plugin
export default {"sticky":"sticky_footer_sticky__y2Dq4","button":"sticky_footer_button__237Mz"};